export default "__VITE_ASSET__0c5329b6__"